
import { GameState } from '../GameContextTypes';

export const setHasTutorialCompleted = (state: GameState, value: boolean): GameState => {
  return {
    ...state,
    hasTutorialCompleted: value
  };
};
